export const urlPattern =
  /^(https?:\/\/)((([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,})|localhost)(:\d{1,5})?(\/[^\s]*)?$/;
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[@#$!%*?&-]).{8,}$/;
